export const EventSystemName = {
  cookieSettings: 'cookieSettings',
  loginChat: 'loginChat',
}



// WEBPACK FOOTER //
// ./src/utils/services/eventSystem/eventSystemName.ts